"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Caret = void 0;
var colors_1 = require("../../../../themes/colors");
var icons_1 = require("../../../../icons");
var react_1 = __importDefault(require("react"));
var styled_1 = require("./styled");
var white = colors_1.colors.white, greyColor100 = colors_1.colors.greyColor100, greyColor40 = colors_1.colors.greyColor40;
var CaretDown = icons_1.icons.CaretDown, CaretUp = icons_1.icons.CaretUp;
var Caret = function (_a) {
    var invert = _a.invert, showOptions = _a.showOptions, disabled = _a.disabled;
    return (react_1.default.createElement(styled_1.StyledCaret, null,
        showOptions ? (react_1.default.createElement(CaretUp, { size: 12, color: invert ? white : greyColor100, weight: "bold" })) : (react_1.default.createElement(CaretDown, { size: 12, color: disabled ? greyColor40 : invert ? white : greyColor100, weight: "bold" })),
        react_1.default.createElement(styled_1.StyledCaretClickArea, null)));
};
exports.Caret = Caret;
